import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Check, X } from 'lucide-react';
export const WhoThisIsFor: React.FC = () => {
  const isFor = ['Tienes una cita de Visa B1/B2 próxima y sientes nervios o miedo.', 'Ya fuiste rechazado antes y no quieres volver a cometer el mismo error.', 'Sientes que tus ingresos o tu perfil "no son suficientes".', 'Quieres llegar a la embajada con un protocolo, no con esperanza.'];
  const isNotFor = ['Buscas falsificar documentos o mentir en el proceso.', 'Necesitas una agencia que gestione todo tu trámite administrativo.'];
  return <SectionWrapper data-id="element-203">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-204">
        {/* Left Column - Yes */}
        <div className="bg-dark-green rounded-2xl p-8 border border-green-900/30 shadow-lg h-full" data-id="element-205">
          <h3 className="text-2xl md:text-3xl font-bold text-green-400 mb-8 flex items-center gap-3" data-id="element-206">
            <Check size={32} strokeWidth={3} data-id="element-207" />
            Esto es para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-208">
            {isFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-209">
                <div className="mt-1 shrink-0" data-id="element-210">
                  <Check className="text-green-500" size={20} strokeWidth={3} data-id="element-211" />
                </div>
                <p className="text-lg text-gray-200 leading-snug" data-id="element-212">{item}</p>
              </li>)}
          </ul>
        </div>

        {/* Right Column - No */}
        <div className="bg-dark-red rounded-2xl p-8 border border-red-900/30 shadow-lg h-full" data-id="element-213">
          <h3 className="text-2xl md:text-3xl font-bold text-red-500 mb-8 flex items-center gap-3" data-id="element-214">
            <X size={32} strokeWidth={3} data-id="element-215" />
            Esto NO es para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-216">
            {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-217">
                <div className="mt-1 shrink-0" data-id="element-218">
                  <X className="text-red-500" size={20} strokeWidth={3} data-id="element-219" />
                </div>
                <p className="text-lg text-gray-200 leading-snug" data-id="element-220">{item}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </SectionWrapper>;
};